module.exports = __webpack_public_path__ + "img/file-earmark-arrow-up-fill.8290f519.svg";